import { Box, styled, Toolbar } from '@mui/material';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import AdmiinLogo from '../../../../../components/AdmiinLogo/AdmiinLogo';
import RightItems from './components/RightItems';
import SearchBox from './components/SearchBox';
import { TopBarProps } from '.';
import { useFirmId } from '../../../../../hooks/useClientWorkflow/useClientWorkflow';

export const TopBarDesktop = (props: TopBarProps) => {
  const { firmId } = useFirmId();
  return (
    <AppBar position="fixed">
      <Toolbar>
        <AdmiinLogo />
        <Box sx={{ mr: 2 }} />
        {firmId && <SearchBox />}
        <Box sx={{ flexGrow: 1 }} />
        <RightItems hasUnreadNotifications />
      </Toolbar>
    </AppBar>
  );
};

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme }) => ({
  zIndex: theme.zIndex.drawer - 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: theme.palette.background.paper,
  borderBottom: `1px solid ${theme.palette.divider}`,
  variants: [
    {
      props: ({ open }) => open,
      style: {
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));
